import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=def08d9a&scoped=true"
import script from "./CreateNews.vue?vue&type=script&lang=js"
export * from "./CreateNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def08d9a",
  null
  
)

export default component.exports